export const environment = {
	production: true,
	clockUrl: "https://test-clock.timetjek.online",
	apiUrl: "https://test-api.timetjek.online",
	clockAppUrl: "https://test-clock2.timetjek.online"
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts